/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { OrganizationRole } from '../model';
// @ts-ignore
import { OrganizationRoleMeResponse } from '../model';
// @ts-ignore
import { OrganizationRoleUpgradeListResponse } from '../model';
/**
 * OrganizationRoleApi - axios parameter creator
 * @export
 */
export const OrganizationRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This operation gives a permission to a requesting organization
         * @summary Approves organization\'s role upgrade
         * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrgRoleUpgradeRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveOrgRoleUpgradeRequest', 'id', id)
            const localVarPath = `/v1/entity/organization/roles/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation requests cancel pending organization role upgrade application.
         * @summary Cancel Organization\'s role upgrade application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrgRoleUpgradeApplication: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization/roles/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves a pending role-upgrade application
         * @summary Gets role-upgrade application if any
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getOrgRoleUpgradeApplication: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization/roles/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves a list of role-upgrade applications
         * @summary Gets role-upgrade applications list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgRoleUpgradeApplicationList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/organization/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation rejects a new organization to use Credify network.
         * @summary Rejects organization onboarding
         * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrganizationRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectOrganizationRequest', 'id', id)
            const localVarPath = `/v1/entity/organization/roles/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation submits an organization role upgrade. This will also handle a new organization\'s onborading.
         * @summary Requests an organization role upgrade
         * @param {OrganizationRole} organizationRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOrgRoleUpgradeRequest: async (organizationRole: OrganizationRole, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRole' is not null or undefined
            assertParamExists('submitOrgRoleUpgradeRequest', 'organizationRole', organizationRole)
            const localVarPath = `/v1/entity/organization/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = organizationRole

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationRoleApi - functional programming interface
 * @export
 */
export const OrganizationRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * This operation gives a permission to a requesting organization
         * @summary Approves organization\'s role upgrade
         * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveOrgRoleUpgradeRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveOrgRoleUpgradeRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation requests cancel pending organization role upgrade application.
         * @summary Cancel Organization\'s role upgrade application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrgRoleUpgradeApplication(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrgRoleUpgradeApplication(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves a pending role-upgrade application
         * @summary Gets role-upgrade application if any
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getOrgRoleUpgradeApplication(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRoleMeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgRoleUpgradeApplication(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves a list of role-upgrade applications
         * @summary Gets role-upgrade applications list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgRoleUpgradeApplicationList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationRoleUpgradeListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgRoleUpgradeApplicationList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation rejects a new organization to use Credify network.
         * @summary Rejects organization onboarding
         * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectOrganizationRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectOrganizationRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation submits an organization role upgrade. This will also handle a new organization\'s onborading.
         * @summary Requests an organization role upgrade
         * @param {OrganizationRole} organizationRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitOrgRoleUpgradeRequest(organizationRole: OrganizationRole, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitOrgRoleUpgradeRequest(organizationRole, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationRoleApi - factory interface
 * @export
 */
export const OrganizationRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationRoleApiFp(configuration)
    return {
        /**
         * This operation gives a permission to a requesting organization
         * @summary Approves organization\'s role upgrade
         * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrgRoleUpgradeRequest(id: string, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.approveOrgRoleUpgradeRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation requests cancel pending organization role upgrade application.
         * @summary Cancel Organization\'s role upgrade application
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrgRoleUpgradeApplication(options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.cancelOrgRoleUpgradeApplication(options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves a pending role-upgrade application
         * @summary Gets role-upgrade application if any
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getOrgRoleUpgradeApplication(options?: any): AxiosPromise<OrganizationRoleMeResponse> {
            return localVarFp.getOrgRoleUpgradeApplication(options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves a list of role-upgrade applications
         * @summary Gets role-upgrade applications list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgRoleUpgradeApplicationList(options?: any): AxiosPromise<OrganizationRoleUpgradeListResponse> {
            return localVarFp.getOrgRoleUpgradeApplicationList(options).then((request) => request(axios, basePath));
        },
        /**
         * This operation rejects a new organization to use Credify network.
         * @summary Rejects organization onboarding
         * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrganizationRequest(id: string, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.rejectOrganizationRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation submits an organization role upgrade. This will also handle a new organization\'s onborading.
         * @summary Requests an organization role upgrade
         * @param {OrganizationRole} organizationRole 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOrgRoleUpgradeRequest(organizationRole: OrganizationRole, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.submitOrgRoleUpgradeRequest(organizationRole, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationRoleApi - interface
 * @export
 * @interface OrganizationRoleApi
 */
export interface OrganizationRoleApiInterface {
    /**
     * This operation gives a permission to a requesting organization
     * @summary Approves organization\'s role upgrade
     * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApiInterface
     */
    approveOrgRoleUpgradeRequest(id: string, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation requests cancel pending organization role upgrade application.
     * @summary Cancel Organization\'s role upgrade application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApiInterface
     */
    cancelOrgRoleUpgradeApplication(options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This retrieves a pending role-upgrade application
     * @summary Gets role-upgrade application if any
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OrganizationRoleApiInterface
     */
    getOrgRoleUpgradeApplication(options?: AxiosRequestConfig): AxiosPromise<OrganizationRoleMeResponse>;

    /**
     * This retrieves a list of role-upgrade applications
     * @summary Gets role-upgrade applications list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApiInterface
     */
    getOrgRoleUpgradeApplicationList(options?: AxiosRequestConfig): AxiosPromise<OrganizationRoleUpgradeListResponse>;

    /**
     * This operation rejects a new organization to use Credify network.
     * @summary Rejects organization onboarding
     * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApiInterface
     */
    rejectOrganizationRequest(id: string, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This operation submits an organization role upgrade. This will also handle a new organization\'s onborading.
     * @summary Requests an organization role upgrade
     * @param {OrganizationRole} organizationRole 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApiInterface
     */
    submitOrgRoleUpgradeRequest(organizationRole: OrganizationRole, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * OrganizationRoleApi - object-oriented interface
 * @export
 * @class OrganizationRoleApi
 * @extends {BaseAPI}
 */
export class OrganizationRoleApi extends BaseAPI implements OrganizationRoleApiInterface {
    /**
     * This operation gives a permission to a requesting organization
     * @summary Approves organization\'s role upgrade
     * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApi
     */
    public approveOrgRoleUpgradeRequest(id: string, options?: AxiosRequestConfig) {
        return OrganizationRoleApiFp(this.configuration).approveOrgRoleUpgradeRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation requests cancel pending organization role upgrade application.
     * @summary Cancel Organization\'s role upgrade application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApi
     */
    public cancelOrgRoleUpgradeApplication(options?: AxiosRequestConfig) {
        return OrganizationRoleApiFp(this.configuration).cancelOrgRoleUpgradeApplication(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves a pending role-upgrade application
     * @summary Gets role-upgrade application if any
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OrganizationRoleApi
     */
    public getOrgRoleUpgradeApplication(options?: AxiosRequestConfig) {
        return OrganizationRoleApiFp(this.configuration).getOrgRoleUpgradeApplication(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves a list of role-upgrade applications
     * @summary Gets role-upgrade applications list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApi
     */
    public getOrgRoleUpgradeApplicationList(options?: AxiosRequestConfig) {
        return OrganizationRoleApiFp(this.configuration).getOrgRoleUpgradeApplicationList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation rejects a new organization to use Credify network.
     * @summary Rejects organization onboarding
     * @param {string} id The &#x60;application_ID&#x60; of organization role upgrade request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApi
     */
    public rejectOrganizationRequest(id: string, options?: AxiosRequestConfig) {
        return OrganizationRoleApiFp(this.configuration).rejectOrganizationRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation submits an organization role upgrade. This will also handle a new organization\'s onborading.
     * @summary Requests an organization role upgrade
     * @param {OrganizationRole} organizationRole 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationRoleApi
     */
    public submitOrgRoleUpgradeRequest(organizationRole: OrganizationRole, options?: AxiosRequestConfig) {
        return OrganizationRoleApiFp(this.configuration).submitOrgRoleUpgradeRequest(organizationRole, options).then((request) => request(this.axios, this.basePath));
    }
}
